// extracted by mini-css-extract-plugin
export default {"CheckboxArea":"Checkbox_CheckboxArea__ueUYf","Checkbox":"Checkbox_Checkbox__yIP9x","Icon":"Checkbox_Icon__sAWry","Children":"Checkbox_Children__DxzAh"};